export default "__VITE_ASSET__hq$lPevh__"